export * from './updateCardDossier.component';
